import JSEncrypt from 'jsencrypt'

function rsaEncrypt (content) {
  const encryptor = new JSEncrypt()
  const pubKey = '-----BEGIN PUBLIC KEY-----MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAz7eNsMaQhg+qe88peeeY+nlxY0ZSohdtupPdRWyT+RHYYGo6uGL2alvE/OjRf9Rn7zU5/emP1T4WWubsD2AbX2V7ZN3EX5Sh3PKF9D1XacDgSyCLE6RRfZmuvLowx1oCysHufXvQRqa/6Sz+LsB8kqlHG/XERdyfvf1fvJ/o/qdOo39ZtYrRxXfDziRdrgestgORKSCVCoAT/cfIHqv+ZWD1jzT2Oye5te4D3t5gFWyGvS7B1V4F81z7nLNNCRCDuIUp//CN7/n89HXb0djEsfFTNiWfoNAgwHUZPX4h7lQqt7dNLlpVwUZKhICGKvxijEqBp0g0cvsu99bs1jdLoQIDAQAB-----END PUBLIC KEY-----'
  encryptor.setPublicKey(pubKey)
  return encryptor.encrypt(content)
}
export default rsaEncrypt
